module.exports = __webpack_public_path__ + "b4b6d6f4cb2a287adc7656ceea603950.pdf";